// extracted by mini-css-extract-plugin
export default {"Wrapper":"ResourcesActions_Wrapper__mXU+X"};